import { Actions, MediaActions } from "./inline-edit-actions";
import Popper from 'popper.js';
import { insertAfter } from '../helpers/elements';
import { getColumnValueFromRowHTML } from "../helpers/rows";
var Selectors = {
    CELL: 'acp-ie-editable',
    VALUE: 'acp-ie-value'
};
var InlineEditCell = /** @class */ (function () {
    function InlineEditCell(InlineEdit, Cell, Middleware, editable_class) {
        this._editableClass = editable_class;
        this.InlineEdit = InlineEdit;
        this.Cell = Cell;
        this.Middleware = Middleware;
        this.Editable = null;
        this.Popper = null;
        this.wrapCellContent();
        this.attachEditable();
        this.insertControls();
        this.attachEvents();
    }
    InlineEditCell.prototype.attachEditable = function () {
        var _this = this;
        if (!this.Cell.dataStorage || this.Editable) {
            return;
        }
        var value = this.Cell.dataStorage.getFormattedValue();
        if (value === null) {
            return;
        }
        this.Editable = new this._editableClass(this.Middleware.getArgs());
        this.Editable.setValue(value);
        if (this.Cell.getObjectID()) {
            this.Editable.setObjectId(this.Cell.getObjectID());
        }
        this.Editable.Events.addListener('save', function (editable) {
            _this.saveValue(editable.getValue());
        });
        this.Editable.Events.addListener('close', function () {
            PopperGlobalEvents.destroy();
            _this.destroyPopper();
        });
    };
    InlineEditCell.prototype.attachEvents = function () {
        var _this = this;
        this.getTargetElement().addEventListener('click', function (e) {
            if (!_this.InlineEdit._enabled || e.target.tagName === 'A') {
                return;
            }
            e.preventDefault();
            e.stopPropagation();
            _this.openEditable();
        });
        document.addEventListener('ACP_InlineEditing_Close', function () {
            if (_this.Popper) {
                _this.Editable.close();
            }
        });
    };
    InlineEditCell.prototype.saveValue = function (value) {
        var _this = this;
        this.Editable.toggleLoading(true);
        this.Cell.dataStorage.storeRevision(value).save().done(function (response) {
            if (!response.success) {
                _this.Editable.toggleLoading(false);
                _this.Editable.setError(response.data.message);
                return;
            }
            _this.setValue(response.data);
            _this.Editable.setValue(response.data.value).close();
            _this.Editable.toggleLoading(false);
            var data = {
                column: _this.Cell.getName(),
                item: _this.Cell.getObjectID(),
                value: response.data.value
            };
            document.dispatchEvent(new CustomEvent('ACP_InlineEditing_After_Save', { detail: data }));
        });
    };
    InlineEditCell.prototype.openEditable = function () {
        var InlineEditable = AdminColumns.Editing.InlineEdit;
        InlineEditable.closeOpenEditables();
        var container = this.getPopperContainer();
        container.append(this.Editable.get());
        this.popper = new Popper(this.getTargetElement(), container, {
            modifiers: {
                arrow: { element: '.ac-edit-popper__caret' }
            }
        });
        InlineEditable._open_editables.push(this.Editable);
        PopperGlobalEvents.bind();
    };
    /**
     * Wraps the content of a cell for better control
     */
    InlineEditCell.prototype.wrapCellContent = function () {
        var _this = this;
        var settings = this.Cell.getSettings().editable;
        var target = document.createElement('span');
        this.Cell.el.classList.add(Selectors.CELL);
        this.Cell.el.classList.add(Selectors.CELL + "--" + settings.type);
        target.classList.add(Selectors.VALUE);
        while (this.Cell.el.firstChild) {
            target.appendChild(this.Cell.el.firstChild);
        }
        this.Cell.el.append(target);
        var InvalidElements = target.querySelectorAll('.row-actions');
        if (InvalidElements) {
            InvalidElements.forEach(function (element) {
                _this.Cell.el.appendChild(element);
            });
        }
        return target;
    };
    InlineEditCell.prototype.undo = function () {
        var _this = this;
        var undo = this.Cell.dataStorage.undo();
        if (undo) {
            this.Cell.dataStorage.save().done(function (response) {
                _this.setValue(response.data);
                _this.Editable.setValue(response.data.value);
            });
        }
    };
    InlineEditCell.prototype.redo = function () {
        var _this = this;
        var redo = this.Cell.dataStorage.redo();
        if (redo) {
            this.Cell.dataStorage.save().done(function (response) {
                _this.setValue(response.data);
                _this.Editable.setValue(response.data.value);
            });
        }
    };
    InlineEditCell.prototype.clear = function () {
        var _this = this;
        this.Cell.dataStorage.storeRevision('').save().done(function (response) {
            _this.setValue(response.data);
            _this.Editable.setValue(response.data.value);
        });
    };
    InlineEditCell.prototype.setCellValue = function (value) {
        var rowActions = this.Cell.el.querySelector('.row-actions');
        this.Cell.el.innerHTML = value;
        if (rowActions) {
            this.Cell.el.append(rowActions);
        }
        this.afterSetValue();
    };
    InlineEditCell.prototype.setValue = function (data) {
        var _this = this;
        var displayValue = data.display_value;
        if (displayValue) {
            this.setCellValue(displayValue);
        }
        else {
            this.getTargetElement().style.backgroundColor = '#f2f093';
            this.getRowsHTML([data.id]).done(function (response) {
                if (!response.hasOwnProperty('data')) {
                    return;
                }
                _this.setValueFromRowHTML(response.data.table_rows[data.id]);
            });
        }
    };
    /**
     * Give the value cell a visual feedback
     */
    InlineEditCell.prototype.valueUpdateVisual = function () {
        var el = this.getTargetElement();
        if (!el) {
            return;
        }
        el.style.animation = 'acp-value-highlight .9s';
    };
    /**
     * Return the element that contains the value
     *
     * @returns {any}
     */
    InlineEditCell.prototype.getTargetElement = function () {
        var el = this.Cell.el.querySelector("." + Selectors.VALUE);
        return el ? el : false;
    };
    InlineEditCell.prototype.insertControls = function () {
        var actions = new Actions(this);
        actions.render();
        if (this.Middleware.hasMediaActions()) {
            var mediaActions = new MediaActions(this);
            mediaActions.render();
        }
        this.moveActions();
    };
    InlineEditCell.prototype.moveActions = function () {
        var settings = this.Cell.getSettings().editable;
        if (!settings.hasOwnProperty('js') || !settings.js.hasOwnProperty('selector')) {
            return;
        }
        var el = this.Cell.el.querySelector(settings.js.selector);
        var actions = this.Cell.el.querySelector('.acp-ie-controls');
        insertAfter(actions, el);
    };
    InlineEditCell.prototype.getRowsHTML = function (ids) {
        if (ids === void 0) { ids = []; }
        return jQuery.ajax({
            url: window.location.href,
            method: 'post',
            data: {
                ac_action: 'get_table_rows',
                ac_ids: ids,
                _ajax_nonce: AC.ajax_nonce
            }
        });
    };
    InlineEditCell.prototype.afterSetValue = function () {
        this.wrapCellContent();
        this.valueUpdateVisual();
        this.insertControls();
        this.attachEvents();
        this.Cell.el.dispatchEvent(new CustomEvent('ACP_InlineEditing_After_SetValue'));
    };
    InlineEditCell.prototype.setValueFromRowHTML = function (rowHTML) {
        var column = this.Cell.getSettings();
        this.setCellValue(getColumnValueFromRowHTML(rowHTML, column.name));
    };
    InlineEditCell.prototype.destroyPopper = function () {
        document.querySelectorAll('.ac-edit-popper').forEach(function (popper) {
            popper.remove();
        });
        if (this.popper) {
            this.popper.destroy();
        }
    };
    InlineEditCell.prototype.getPopperContainer = function () {
        this.Popper = document.createElement('div');
        this.Popper.classList.add('ac-edit-popper');
        this.Popper.insertAdjacentHTML('afterbegin', '<span class="ac-edit-popper__caret">');
        document.body.append(this.Popper);
        return this.Popper;
    };
    return InlineEditCell;
}());
export default InlineEditCell;
var PopperGlobalEvents = /** @class */ (function () {
    function PopperGlobalEvents() {
    }
    PopperGlobalEvents.bind = function () {
        document.addEventListener('keyup', PopperGlobalEvents.escapeEvent);
        document.addEventListener('click', PopperGlobalEvents.clickEvent);
        document.querySelectorAll('.select2-container--acs2').forEach(function (c) {
            c.addEventListener('click', function (e) {
                e.stopPropagation();
            });
        });
    };
    PopperGlobalEvents.destroy = function () {
        document.removeEventListener('keyup', PopperGlobalEvents.escapeEvent);
        document.removeEventListener('click', PopperGlobalEvents.clickEvent);
    };
    PopperGlobalEvents.escapeEvent = function (e) {
        if (e.key === "Escape") {
            document.dispatchEvent(new CustomEvent('ACP_InlineEditing_Close'));
        }
    };
    PopperGlobalEvents.clickEvent = function (e) {
        if (e.target === document.body) {
            return;
        }
        if (PopperGlobalEvents.checkInvalidParentClasses(e.target)) {
            return;
        }
        document.dispatchEvent(new CustomEvent('ACP_InlineEditing_Close'));
    };
    PopperGlobalEvents.checkInvalidParentClasses = function (el) {
        var isInvalid = false;
        var invalidClasses = [
            'mce-container',
            'wp-editor-wrap',
            'media-modal',
            'select2-container',
            'ui-datepicker',
            'ui-datepicker-header',
            'ui-datepicker-buttonpane'
        ];
        invalidClasses.map(function (c) {
            if (el.classList.contains(c))
                isInvalid = true;
        });
        if (isInvalid) {
            return true;
        }
        if (!el.parentElement) {
            return false;
        }
        return PopperGlobalEvents.checkInvalidParentClasses(el.parentElement);
    };
    return PopperGlobalEvents;
}());
